import debounce from 'lodash.debounce'
import { reqSeenMentions, SeenMentions } from '@weblite/ts-action/subscription'
import * as seenMentionSync from './offline-sync'
import { getSubscription } from '$logic/subscription'
import { subscriptionsStorage } from '$logic/subscription/storage'
import { request } from '$setup/ws'
import { getRoom } from '$logic/room'

const DEBOUNCE_WAIT_FOR_SYNCING_SEEN_MENTION = 5000

async function getMentions(roomId: string) {
  const subscription = await getSubscription(roomId)
  return subscription?.mentions ?? []
}

async function requestSyncMentionSeen() {
  const { items, del } = await seenMentionSync.getAll()
  if (!items.length) {
    await del()
    return []
  }
  const res = await request<SeenMentions>(reqSeenMentions({ patches: items }))
  await del()
  return res.payload.updated
}

export async function syncMentionSeen() {
  const updated = await requestSyncMentionSeen()
  updated.forEach(({ mentions, hallId, updatedAt }) =>
    subscriptionsStorage.set(hallId, { updatedAt, mentions }),
  )
}

const syncSeenMentionWithDelay = debounce(
  syncMentionSeen,
  DEBOUNCE_WAIT_FOR_SYNCING_SEEN_MENTION,
)

export async function setSeenMention(roomId: string, seen: number) {
  const room = await getRoom(roomId)
  if (room.type !== 'GROUP') return

  const mentions = await getMentions(roomId)

  if (!mentions.includes(seen)) return

  await subscriptionsStorage.set(roomId, {
    mentions: mentions.filter(iid => iid !== seen),
  })

  await seenMentionSync.set(roomId, seen)

  syncSeenMentionWithDelay()
}
